import { api } from '@/api';

export type LogoutResponse = object;

type GetLogoutProps = {
  abortController?: AbortController;
};

const getLogoutApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLogout: builder.query<LogoutResponse, GetLogoutProps>({
      query: ({ abortController = new AbortController() }: GetLogoutProps) => ({
        url: `logout`,
        method: 'POST',
        body: {},
        signal: abortController.signal,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetLogoutQuery } = getLogoutApi;
